// src/constants/formLinks.js

export const FORM_LINKS = {
    PGCD_FRANCAIS: "https://dl.tsahalco.com/pgcdfr",
    PGCD_HEBREU: "https://dl.tsahalco.com/pgcdhe",
    FORMULAIRE_MEDICAL_TSAV1_HEBREU: "https://dl.tsahalco.com/tzav1medhe",
    FORMULAIRE_MEDICAL_TSAV1_ANGLAIS: "https://dl.tsahalco.com/tzav1meden",
    MAHAL_FORMULAIRE_TOURISTE_ANGLAIS: "https://dl.tsahalco.com/mahaltouristen",
    MAHAL_FORMULAIRE_TOURISTE_HEBREU: "https://dl.tsahalco.com/mahaltouristhe",
    MAHAL_FORMULAIRE_BEN_MEAGER_ANGLAIS: "https://dl.tsahalco.com/mahalbmen",
    MAHAL_FORMULAIRE_BEN_MEAGER_HEBREU: "https://dl.tsahalco.com/mahalbmhe",
    FORMULAIRE_ENFANT_UNIQUE_ANGLAIS: "https://dl.tsahalco.com/yahiden",
    FORMULAIRE_ENFANT_UNIQUE_HEBREU: "https://dl.tsahalco.com/yahidhe",
    EXPLICATION_ENFANT_UNIQUE: "https://dl.tsahalco.com/yahidtable",
    LISTE_POSTES_TSAHAL_OCT24: "https://dl.tsahalco.com/postes",
    LISTE_ETUDES_ATOUDA_AKADEMIT: "https://dl.tsahalco.com/atoudalist",
    FORMULAIRE_AVANCER_REPORTER_GIYUS: "https://dl.tsahalco.com/changegiyus",
    FORMULAIRE_ATOUDA_OLIM: "https://dl.tsahalco.com/atoudatolim",
    MODELE_SAYAROT_GARCONS_2024: "https://dl.tsahalco.com/mensayarot",
    MODELE_SAYAROT_FILLES_2024: "https://dl.tsahalco.com/womensayarot",
    AFFAIRES_GIYUS_CARTE_ETOILE: "https://dl.tsahalco.com/listgiyus",
    ATTESTATION_NON_ENFANT_UNIQUE: "https://dl.tsahalco.com/notarynonyahid",
    EXPLICATION_FORMULAIRE_MAHAL: "https://dl.tsahalco.com/mahalexpl",
    STATUT_ENFANT_UNIQUE_A_TORT: "https://dl.tsahalco.com/explnonyahid",
    MECHINOT_OFEK_6_MOIS: "https://dl.tsahalco.com/mehinotofek",
    MECHINOT_ANNUELLES: "https://dl.tsahalco.com/mehinot1year",
    MECHINOT_RELIGIEUSES: "https://dl.tsahalco.com/mehinotdatiot",
    SOLDATS_SEULS_SALAIRES: "https://dl.tsahalco.com/boded",
    EXPLICATION_FORMULAIRE_MEDICAL_TSAV1: "https://dl.tsahalco.com/explmed",
    DEMANDE_ANNULATION_ANNEE_INTEGRATION: "https://dl.tsahalco.com/istaglout",
    DEMANDE_TEST_MODIIN: "https://dl.tsahalco.com/modiin",
    FORMULAIRE_ATOUDA_AKADEMIT: "https://dl.tsahalco.com/akademit",
    FORMULAIRE_MEDICAL_YOM_SAYAROT_GIBBUSHIM: "https://dl.tsahalco.com/medsayarot",
    AFFAIRES_MECHINA_BY_TC: "https://dl.tsahalco.com/mehinamahal",
    DOCS_BANQUE_MAHAL: "https://dl.tsahalco.com/bankmahal",
    MAHAL_CHECKLIST_DOCS: "https://dl.tsahalco.com/listmahal",
  };
  